import { joiResolver } from "@hookform/resolvers/joi";
import Joi from "joi";
import { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import InputForm from "src/components/forms/InputForm";
import Title from "src/components/Title";
import API from "src/services/api";

const TagAddEditSite = () => {
  // Parameter tag_id aus URL auslesen
  const { tag_id } = useParams();
  const navigate = useNavigate();

  // Validierungsschema
  const schema = Joi.object({
    name: Joi.string().required(),
    icon: Joi.string(),
    gui_order: Joi.number().required(),
  });

  const {
    reset,
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    resolver: joiResolver(schema),
  });

  const loadData = async () => {
    const res = await API.getTag(tag_id);
    if (res.status === true) {
      reset({
        name: res.data.name,
        icon: res.data.icon,
        gui_order: res.data.gui_order,
      });
    }
  };
  // Load notes when component is rendered the first time
  useEffect(() => {
    if (tag_id) {
      loadData();
    }
  }, [tag_id]);

  const onSubmit = async (formData) => {
    console.log("TagAddEditSite", formData);

    let result;
    if (tag_id) {
      result = await API.updateTag(tag_id, formData);
    } else {
      result = await API.createTag(formData);
    }

    console.log("result", result);

    if (result.status === true && result.data.id) {
      console.log("ok");
      // Redirect
      navigate(`/tag/${result.data.id}`);
    } else {
      console.log("error");
      // Error
    }
  };

  return (
    <Row>
      <Col>
        <Title>Tag {tag_id ? "bearbeiten" : "erstellen"}</Title>
        <Form onSubmit={handleSubmit(onSubmit)} onReset={reset}>
          <Row>
            <Col>
              <InputForm
                id="name"
                label="Name"
                register={register}
                errors={errors}
              />
              <InputForm
                id="icon"
                label="Icon"
                register={register}
                errors={errors}
              />
              <InputForm
                id="gui_order"
                label="GUI-Reihenfolge"
                type="number"
                register={register}
                errors={errors}
              />
              <Button
                variant="warning"
                type="submit"
                onClick={handleSubmit(onSubmit)}
              >
                Speichern
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default TagAddEditSite;
